import { trimSpecialCharacters } from 'features/order-tracker/utils';

import { AVAILABLE_ORDER_STATUSES } from './constants';

interface OrderSummaryResponse {
  result: {
    OrderMetaInfo: dto.OrderSummaryMetaInfo;
    Products: (dto.Product & { CVPackageLinkedProducts?: string[]; RelatedOrderItemReferences?: string })[];
    IsShowAppointment: boolean;
  };
}

interface TransformedOrderSummary {
  OrderStatus: string | undefined;
  EstimatedCompletionDate: string;
  placedOn: string;
  products: transformedResponse.Product[];
  groupId: string;
  IsShowAppointment: boolean;
  allProducts: (dto.Product & { CVPackageLinkedProducts?: string[]; RelatedOrderItemReferences?: string })[];
}

export class OrderSummaryService {
  static transformResponse(
    { result: { OrderMetaInfo, Products, IsShowAppointment } }: OrderSummaryResponse,
  ): TransformedOrderSummary {
    const { OrderPlacedDate, EstimatedCompletionDate, OrderStatus, GrouperOrderId } = OrderMetaInfo;
    const CVPackageLinkedProductsList = this.getCVPackageLinks(Products);

    const products = Products.filter(
      ({ IsBundleProduct, OrderItemReference, RelatedOrderItemReferences }) =>
        !IsBundleProduct && !CVPackageLinkedProductsList.includes(OrderItemReference) && !RelatedOrderItemReferences,
    );
    return {
      OrderStatus: this.normalizeStatus(OrderStatus),
      EstimatedCompletionDate,
      placedOn: OrderPlacedDate,
      products: this.mapProducts(products),
      groupId: GrouperOrderId,
      IsShowAppointment,
      allProducts: Products,
    };
  }

  static mapProducts(
    products: (dto.Product & { CVPackageLinkedProducts?: string[]; RelatedOrderItemReferences?: string })[],
  ): transformedResponse.Product[] {
    return products.map(({ OrderItemReference, ProductName, ProductType }) => ({
      orderItemReference: OrderItemReference,
      productName: trimSpecialCharacters(ProductName),
      productType: ProductType,
    }));
  }

  static getCVPackageLinks(products: (dto.Product & { CVPackageLinkedProducts?: string[] })[]): string[] {
    return products.reduce<string[]>((acc, { CVPackageLinkedProducts }) => {
      CVPackageLinkedProducts && acc.push(...CVPackageLinkedProducts);
      return acc;
    }, []);
  }

  static normalizeStatus(orderStatus: string): string | undefined {
    return AVAILABLE_ORDER_STATUSES.find(
      (status) => status.toLowerCase() === orderStatus.toLowerCase().replace(/_/g, ' '),
    );
  }
}
